import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"

const api = new APIClient();

// Get user calendar
export const getUserCalendar = () => api.get(url.GET_USER_CALENDAR, {});
export const getCalendarByUserID = (id: string) => api.get(`${url.GET_USER_CALENDAR}/${id}`, {});
